import {
    useCallback, useMemo,
} from 'react'
import SkyNetLink, {
    SizeLink, TypeLink,
} from 'app/shared-components/SkyNetLink'
import useGetLaneGroup from 'app/Apps/Pricing/LaneGroups/hooks/useGetLaneGroup'
import useDelayedLoadOptions from 'app/hooks/useDelayedLoadOptions'
import ContractBasisRequests, {
    laneGroupSelectorConversion,
} from 'app/requests/ContractBasis/ContractBasis.requests'
import Typeahead from 'app/shared-components/Typeahead'

export default function LaneGroupByContractSelector({
    name = '',
    value,
    onChange,
    title = 'Lane Group',
    className = '',
    disabled = false,
    required = false,
    noneOption = true,
    contractId,
    generateLink,
}: Readonly<{
    name?: string,
    value?: {
        id: number | string,
    },
    onChange: (value: { id: number }) => void,
    title?: string,
    disabled?: boolean,
    className?: string,
    required?: boolean,
    noneOption?: boolean,
    contractId: number,
    generateLink?: (id: string | number) => string
}>) {
    const loadOptions = useDelayedLoadOptions({
        ...ContractBasisRequests.filterRequestLaneGroups({
            contractId,
        }),
        convertion: laneGroupSelectorConversion,
    })

    const {
        data,
        isDataReady,
    } = useGetLaneGroup(value?.id)

    const onChangeValue = useCallback((newValue) => {
        const convertedValue = newValue ? {
            id: newValue,
        } : undefined

        onChange(convertedValue)
    }, [onChange])

    const labelData = useMemo(() => {
        if (data) {
            return {
                label: data?.laneGroupNumber,
            }
        }

        return null
    }, [data])

    if (isDataReady && disabled && generateLink) {
        const link = generateLink(value?.id)

        return link ? (
            <SkyNetLink
                type={TypeLink.EXTERNAL}
                size={SizeLink.S}
                link={generateLink(value?.id)}
                text={labelData?.label}
                title={title}
            />
        ) : null
    }

    return (
        <Typeahead
            name={name}
            title={title}
            className={className}
            onChange={onChangeValue}
            loadOptions={loadOptions}
            labelData={labelData}
            labelField="label"
            value={value?.id}
            disabled={disabled}
            isRequired={required}
            noneOption={noneOption}
        />
    )
}
